var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62051_12397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 0C3.91427 0 0.333496 3.58077 0.333496 8C0.333496 12.4192 3.91427 16 8.3335 16C12.7527 16 16.3335 12.4192 16.3335 8C16.3335 3.58077 12.7527 0 8.3335 0ZM7.09888 10.8346C7.00657 10.9269 6.8758 11.0038 6.76042 11.0038C6.64503 11.0038 6.51427 10.9231 6.41811 10.8308L4.60657 9.01923C4.41752 8.83018 4.41752 8.52367 4.60657 8.33462C4.79562 8.14556 5.10214 8.14556 5.29119 8.33462L6.76427 9.80769L11.2163 5.32352C11.4073 5.13114 11.7191 5.13321 11.9075 5.3281C12.0907 5.51757 12.0886 5.81879 11.9027 6.00563L7.09888 10.8346Z",
    fill: "#28FF61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09888 10.8346C7.00657 10.9269 6.8758 11.0038 6.76042 11.0038C6.64503 11.0038 6.51427 10.9231 6.41811 10.8308L4.60657 9.01923C4.41752 8.83018 4.41752 8.52367 4.60657 8.33462C4.79562 8.14556 5.10214 8.14556 5.29119 8.33462L6.76427 9.80769L11.2163 5.32352C11.4073 5.13114 11.7191 5.13321 11.9075 5.3281C12.0907 5.51757 12.0886 5.81879 11.9027 6.00563L7.09888 10.8346Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62051_12397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.333496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusPaid);
export default __webpack_public_path__ + "static/media/statusPaid.9486c074389bd727fcc667fca9dab96d.svg";
export { ForwardRef as ReactComponent };